import { useMemo } from "react";
import Card, { CardHeader } from "components/card";
import Chart from "components/charts/Chart";
import { palette } from "lib/chartTheme";
import { ARCHETYPE_KEYS, ARCHETYPES } from "lib/archetypes";

const OPTIONS = {
  xaxis: { categories: ARCHETYPE_KEYS.map((key) => ARCHETYPES[key].label) },
  yaxis: { show: false, max: 100 },
  fill: { opacity: 0.25 },
  markers: { size: 3 },
  colors: [palette.sage],
};

const TeamCompositionRadar = ({ strengthsMatrix }) => {
  const series = useMemo(
    () => [
      {
        name: "Team Average",
        data: ARCHETYPE_KEYS.map((key) => Number(strengthsMatrix?.[key]) || 0),
      },
    ],
    [strengthsMatrix]
  );

  if (!strengthsMatrix) return null;

  return (
    <Card padding="md">
      <CardHeader title="Team Composition" className="mb-4" />
      <Chart
        type="radar"
        series={series}
        options={OPTIONS}
        height="lg"
        empty={series[0].data.every((score) => !score)}
        emptyText="No completed assessments yet"
      />
    </Card>
  );
};

export default TeamCompositionRadar;
